import { FileText } from 'lucide-react'
import { Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

const isImageUrl = (url: string): boolean => {
  const path = url.split('?')[0]
  const ext = path.split('.').pop()?.toLowerCase() ?? ''
  return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(ext)
}

export const AttachmentList = ({
  urls,
  className,
  linkClassName,
}: {
  urls: string[]
  className?: string
  linkClassName?: string
}) => {
  const { t } = useLocalization()
  if (!urls?.length) return null

  return (
    <Row className={className} style={{ flexWrap: 'wrap', gap: '0.5rem' }}>
      {urls.map((url, i) => {
        const isImage = isImageUrl(url)
        return (
          <a
            key={`${url}-${i}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={linkClassName}
          >
            {isImage ? (
              <img
                src={url}
                alt={t('Attachment', 'Bilaga')}
                className="max-h-20 max-w-[120px] rounded object-cover"
              />
            ) : (
              <Row className="items-center gap-1.5 rounded border px-2 py-1.5 text-xs hover:bg-gray-100">
                <FileText className="w-4 h-4 shrink-0" />
                <span className="truncate max-w-[100px]">
                  {url.split('/').pop() ?? t('File', 'Fil')}
                </span>
              </Row>
            )}
          </a>
        )
      })}
    </Row>
  )
}
